"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
class BasicApi {
  constructor(_ref) {
    let {
      userTokenFactory,
      accountIdFactory,
      timeout,
      baseURL,
      accountId
    } = _ref;
    this.userTokenFactory = userTokenFactory;
    this._accountIdFactory = accountIdFactory;
    this.accountId = accountId;
    this.axios = _axios.default.create({
      baseURL,
      timeout
    });
  }

  // TODO: remove this method
  get headers() {
    return {
      headers: {
        Authorization: this.userToken
      }
    };
  }
  async getHeaders(token) {
    const userToken = token || this.userToken;
    return {
      headers: {
        Authorization: userToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    };
  }
  get userToken() {
    return this.userTokenFactory();
  }
  get accountIdFactory() {
    if (_lodash.default.isFunction(this._accountIdFactory)) return this._accountIdFactory();
    return 'unset';
  }
  static getErrorMessage(e) {
    const responseData = _lodash.default.get(e, 'response.data');
    const errorMessage = _lodash.default.get(e, 'message');
    const responseError = _lodash.default.get(responseData, 'error', responseData);
    return _lodash.default.isString(responseError) ? responseError : _lodash.default.isEmpty(responseError) ? errorMessage : JSON.stringify(responseError);
  }
  async _callApi(_ref2) {
    let {
      url,
      data,
      method,
      params
    } = _ref2;
    const {
      data: res
    } = await this.axios({
      url,
      method,
      data,
      params: {
        accountId: _lodash.default.isFunction(this._accountIdFactory) ? this._accountIdFactory() : this.accountId,
        ...params
      },
      headers: {
        Authorization: this.userToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).catch(e => {
      throw new Error(this.constructor.getErrorMessage(e));
    });
    return res;
  }
}
var _default = BasicApi;
exports.default = _default;